// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-list-container {
  height: calc(100% - 96px);
  width: 100%;
  overflow-y: auto;
}

.contact-list-container.searching {
  height: calc(100% - 56px);
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Contacts/SideBar/SideBar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".contact-list-container {\n  height: calc(100% - 96px);\n  width: 100%;\n  overflow-y: auto;\n}\n\n.contact-list-container.searching {\n  height: calc(100% - 56px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
